import React from 'react'
import Modal from 'react-modal'
import { Board } from 'react-trello'
import update from 'immutability-helper'
import moment from 'moment'
import { browserHistory } from 'react-router'

import UsersSelect from '../../components/Users/UsersSelect'

import { user } from '../../core/controllers/user';
import { collaboratorManager } from '../../core/controllers/CollaboratorManager';
import { modal } from '../../core/utilities/modal';
import { modalStyles } from '../../core/controllers/ModalStyles';

export default class CollaboratorTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            description: '',
            id: 0,
            cards: [],
            updateType: 'Add',
            isMovingCard: false,
            loaded: false,
            assigned_to: 0,
            isTemplate: false,
            address: '',
            name: '',
            showTaskModal: false,
            createdAt: '',
            taskBoardsList: ["Task Board 1", "Task Board 2", "Task Board 3"], //TODO: Wait for API to update this list. Dummy data for now
        }
    }

    componentDidMount() {
        var self = this;
        collaboratorManager.getCards(function(cards) {
            self.setState({
                cards:cards.data,
                loaded: true
            });
        });
    }

    componentDidUpdate() {
    }

    dragStart(id) {
        this.setState({isMovingCard: true});
    }

    dragEnd(id) {
        this.setState({isMovingCard: false});
    }

    handleAssigneeChange(e) {
        this.setState({
            assigned_to: e.target.value
        });
    }

    onDataChange(data) {
        var self = this;
        if(this.state.isMovingCard) {
            var cardsToChange = [];
            data.lanes.forEach(lane => {
                lane.cards.forEach(card => {
                    self.state.cards.forEach(data => {
                        if (card.id == data.collaborator_card_id && data.lane != lane.id) {
                            cardsToChange.push({id: card.id, lane: lane.id});
                        }
                    })
                });
            });

            if (cardsToChange.length > 0) {
                collaboratorManager.cardsMoved(cardsToChange, function(response) {
                    // maybe do something
                });
            }
        }
    }

    handleOpenTaskModal(value) {
        if (value == "add_task") {
            this.setState({
                title: '',
                description: '',
                id: 0,
                updateType: 'Add',
                showTaskModal: true,
            });
        } else {
            var self = this;
            collaboratorManager.getCard(value, function(response) {
                self.setState({
                    id: value,
                    title: response.data.title,
                    description: response.data.description,
                    updateType: 'Edit',
                    assigned_to: response.data.assigned_to,
                    isTemplate: false,
                    showTaskModal: true,
                    createdAt: response.data.created_at,
                });
            });
        }
    }

    handleCloseTaskModal() {
        this.setState({
            showTaskModal: false,
        });
    }

    onTitleChange(e) {
        this.setState({title: e.target.value});
    }

    onDescriptionChange(e) {
        this.setState({description: e.target.value});
    }

    onNameChange(e) {
        this.setState({name: e.target.value});
    }

    onAddressChange(e) {
        this.setState({address: e.target.value});
    }

    validate(type) {
        if (type == "card") {
            if (this.state.title == '') {
                modal.showInfo("Enter a task title!", "warning", "top", "center");
                return false;
            } else if (this.state.description == '') {
                modal.showInfo("Enter a task description!", "warning", "top", "center");
                return false;
            }
        } else if (type == "move_out_checklist") {
            if (this.state.name == '') {
                modal.showInfo("Enter the tenant's name.", "warning", "top", "center");
                return false;
            } else if (this.state.address == '') {
                modal.showInfo("Enter the property address.", "warning", "top", "center");
                return false;
            }
        }

        return true;
    }

    createMoveOutChecklist() {
        if (!this.validate("move_out_checklist")){
            return;
        }
        var self = this;
        collaboratorManager.createMoveOutChecklist({name: this.state.name, address: this.state.address, assigned_to: this.state.assigned_to}, function(response) {
            modal.showInfo("Move Out Checklist Created!", "success", "top", "center");

            response.data.forEach(card => {
                self.eventBus.publish({
                    type: 'ADD_CARD',
                    laneId: '1',
                    card: {
                        id: card.collaborator_card_id,
                        title: card.title,
                        label: "",
                        description: card.description
                    }
                });
            });

            var updateCards = self.state.cards;
            updateCards.push(response.data);
            self.setState({
                id: 0,
                title: '',
                description: '',
                cards: updateCards,
                address: '',
                name: '',
                isTemplate: false,
                showTaskModal: false,
            });
        });
    }

    updateTask() {
        if (!this.validate("card")){
            return;
        }

        if (this.state.updateType == 'Add') {
            var self = this;
            collaboratorManager.addCard('new', {title: this.state.title, description: this.state.description, assigned_to: this.state.assigned_to}, function(response) {
                modal.showInfo("Task Successfully Added!", "success", "top", "center");
                self.eventBus.publish({type: 'ADD_CARD', laneId: '1', card: {id: response.data.collaborator_card_id, title: response.data.title, label: "", description: response.data.description}});

                var updateCards = self.state.cards;
                updateCards.push(response.data);
                self.setState({
                    id: 0,
                    title: '',
                    description: '',
                    cards: updateCards,
                    address: '',
                    name: '',
                    showTaskModal: false,
                });
            });
        } else {
            var self = this;
            collaboratorManager.updateCard(this.state.id, {title: this.state.title, description: this.state.description, assigned_to: this.state.assigned_to}, function(response) {
                modal.showInfo("Task Successfully Updated!", "success", "top", "center");
                collaboratorManager.getCards(function(cardData) {
                    const cards = cardData.data;
                    var id;
                    var lane;
                    var detectedCard;
                    cards.forEach(function(data) {
                        if(data.collaborator_card_id == self.state.id) {
                            detectedCard = {id: data.collaborator_card_id, title: data.title, description: data.description};
                            lane = data.lane;
                            id = data.collaborator_card_id;
                        }
                    });

                    self.eventBus.publish({type: 'REMOVE_CARD', laneId: lane, cardId: id});
                    self.eventBus.publish({type: 'ADD_CARD', laneId: lane, card: detectedCard});

                    self.setState({
                        cards: cardData.data,
                        id: 0,
                        title: '',
                        description: '',
                        address: '',
                        name: '',
                        showTaskModal: false,
                    });
                });
            });
        }
    }

    setEventBus(bus) {
        this.eventBus = bus;
    }

    deleteCard() {
        var self = this;

        modal.showDangerModalWithOK("Are you sure?","You are about to delete this task.", "Yes, Delete");
        jQuery(".move-on").on('click',function() {
            collaboratorManager.deleteCard(self.state.id, function(response) {
                self.eventBus.publish({type: 'REMOVE_CARD', laneId: response.lane, cardId: self.state.id});
                modal.showInfo("Task Successfully Deleted!", "success", "top", "center");
                self.setState({
                    id: 0,
                    title: '',
                    description: '',
                    showTaskModal: false,
                });
            });
        })
    }

    optionChange(e) {
        if (e.target.value == '1') {
            this.setState({
                isTemplate: true
            });
        } else {
            this.setState({
                isTemplate: false
            });
        }
    }

    handleTaskBoardChange() {
        //TODO: wait for API change
    }

    render(){
        const title = this.state.title;
        const description = this.state.description;
        const updateType = this.state.updateType;
        const isTemplate = this.state.isTemplate;
        const isLoaded = this.state.loaded;
        const assignedTo = this.state.assigned_to;
        const name = this.state.name;
        const address = this.state.address;
        const createdAt = this.state.createdAt;
        var addButtonText = 'Add';
        if (updateType != 'Add') {
            addButtonText = 'Update'
        }
        const cards = this.state.cards;
        var placement1 = [];
        var placement2 = [];
        var placement3 = [];
        var placement4 = [];
        var hasData = false;
        cards.forEach(function(data) {
            const card = {id: data.collaborator_card_id, title: data.title, description: data.description};
            if(data.lane == 1) {
                placement1.push(card);
                hasData = true;
            } else if (data.lane == 2) {
                placement2.push(card);
                hasData = true;
            } else if (data.lane == 3) {
                placement3.push(card);
                hasData = true;
            } else if (data.lane == 4) {
                placement4.push(card);
                hasData = true;
            }
        });
        const data = {
            lanes: [
                {
                    id: '1',
                    title: 'Ideas',
                    label: '',
                    cards: placement1
                },
                {
                    id: '2',
                    title: 'To Do',
                    label: '',
                    cards: placement2
                },
                {
                    id: '3',
                    title: 'In Progress',
                    label: '',
                    cards: placement3
                },
                {
                    id: '4',
                    title: 'Done',
                    label: '',
                    cards: placement4
                }
            ]
        }

        return (
        <div class="col-md-12" >
            <div class="row">
                <div class="main-page-header-row col-md-12">
                    {hasData == true ? (
                    <div>
                        <div class="col-md-3">
                            <span class="main-page-header-title">Tasks</span>
                        </div>
                        <button type="button" id="add-task" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" onClick={this.handleOpenTaskModal.bind(this, "add_task")} autoComplete="off">
                            Add Task
                        </button>
                        <div class="clearfix"></div>
                    </div>
                    ) : (
                    <div style={{textAlign: "center"}}>
                        <div class="row">
                            <span class="main-page-header-title">No Tasks Yet</span>
                        </div>
                        <div class="row" style={{marginTop: "10px"}}>
                            <button type="button" id="add-task" data-loading-text="Loading..." class="btn btn-info btn-fill" onClick={this.handleOpenTaskModal.bind(this, "add_task")} autoComplete="off">
                                Add Task
                            </button>
                            <div class="clearfix"></div>
                        </div>
                        <div class="col-md-12" style={hasData == false ? {backgroundImage: "url('assets/img/Steve@4x-8.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: '30%'} : {}}></div>
                    </div>
                    )}      
                </div>
            </div>
            {/* <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="task-boards" style={{color: "#FFFFFF"}}>Select Task Board</label>
                        <select class="form-control" value={0} onChange={this.handleTaskBoardChange.bind(this)}>
                            {this.state.taskBoardsList.map(function(item) {
                            return <option value={item}>{item}</option>
                            })}
                        </select>
                    </div>
                </div>
            </div> */}
            <Modal
                isOpen={this.state.showTaskModal}
                onRequestClose={this.handleCloseTaskModal.bind(this)}
                style={modalStyles.getModalStyles()}
                ariaHideApp={false}
            >
            <div class="row">
                <div class="modal-exit-icon pull-right" onClick={this.handleCloseTaskModal.bind(this)}></div>
            </div>
            {updateType == "Add" ? (
                <div class="row">
                    <div class="modal-header">Add a Task</div>
                </div>
            ) : (
                <div class="row">
                    <div class="modal-header">{title}</div>
                </div>
            )}
            <div class="row">
                <div class="modal-section-title col-md-12">Task Information</div>
                {updateType != "Add" && (
                <div>
                    <div class="row">
                        <div class="modal-section-note-title">Date Created</div>
                    </div>
                    <div class="row">
                        <div class="modal-section-note-date">{moment.utc(createdAt).local().format('DD MMM YYYY, h:mm A')}</div>
                    </div>             
                </div>
                )}
            </div>
            <form>
                {updateType == "Add" && (
                <div class="row">
                    <div class="form-group">
                        <small>What would you like to add?</small>
                        <select class="form-control" onChange={this.optionChange.bind(this)}>
                            <option value="0">Add a Task</option>
                            <option value="1">Move Out Checklist</option>
                        </select>
                    </div>
                </div>
                )}
                { isTemplate == true ? (
                <div>
                    <h4 style={{'borderBottom': '1px solid #e1e1e1','textAlign': 'center'}}>Move Out Checklist</h4>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Name*</label>
                                <input type="text" name="name" class="form-control" id="name" placeholder="Name" value={name} onChange={this.onNameChange.bind(this)}/>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Assigned User</label>
                                <UsersSelect disabled={false} columnSize={12} accountType="all" sortID={assignedTo} onChange={this.handleAssigneeChange.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="task-description">Address*</label>
                                <input name="address" class="form-control" id="address" value={address} placeholder="Address" onChange={this.onAddressChange.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="content">
                            { updateType == "Add" ? (
                            <div class="col-md-8 col-md-offset-4">
                                <button type="button" id="add-task" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.createMoveOutChecklist.bind(this)}>
                                    Create Task List
                                </button>
                            </div>
                            ) : (
                            <div class="col-md-12">
                                <div class="col-md-3 col-md-offset-2">
                                    <button type="button" id="delete-task" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteCard.bind(this)}>
                                        Delete Task List
                                    </button>
                                </div>
                                <div class="col-md-3 col-md-offset-1">
                                    <button type="button" id="update-task" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.createMoveOutChecklist.bind(this)}>
                                        Update Task List
                                    </button>
                                </div>
                            </div>
                            )}
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
                ) : (
                <div>
                    <h4 style={{'borderBottom': '1px solid #e1e1e1','textAlign': 'center'}}>{updateType} Task</h4>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Name*</label>
                                <input type="text" name="title" class="form-control" id="title" placeholder="Title" value={title} onChange={this.onTitleChange.bind(this)}/>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Assigned User</label>
                                <UsersSelect disabled={false} columnSize={12} accountType="all" sortID={assignedTo} onChange={this.handleAssigneeChange.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="task-description">Description*</label>
                                <textarea rows="8" cols="80" name="description" class="form-control" id="description" placeholder="Description" value={description} onChange={this.onDescriptionChange.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="content">
                            { updateType == "Add" ? (
                            <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                <button type="button" id="add-task" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.updateTask.bind(this)}>
                                    Create Task
                                </button>
                            </div>
                            ) : (
                            <div class="col-md-12">
                                <div class="col-md-3 col-md-offset-2 col-sm-3 col-sm-offset-2 col-xs-6">
                                    <button type="button" id="delete-task" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteCard.bind(this)}>
                                        Delete Task
                                    </button>
                                </div>
                                <div class="col-md-3 col-sm-3 col-sm-offset-1 col-xs-6">
                                    <button type="button" id="update-task" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.updateTask.bind(this)}>
                                        Update Task
                                    </button>
                                </div>
                            </div>
                            )}
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
                )}
            </form>
            </Modal>
            { isLoaded == true && (
            <div class="row">
                <Board data={data}
                    draggable={true}
                    handleDragStart={this.dragStart.bind(this)}
                    handleDragEnd={this.dragEnd.bind(this)}
                    onCardClick={this.handleOpenTaskModal.bind(this)}
                    onDataChange={this.onDataChange.bind(this)}
                    eventBusHandle={this.setEventBus.bind(this)}/>
            </div>
            )}
        </div>
        )
    }
};



// WEBPACK FOOTER //
// app/views/Collaborator/Collaborator.jsx